import { cx } from '../../utils/cx';
import { Button, type ButtonProps } from '../button/button';
import { Icon, type IconProps } from '../icon/icon';

import styles from './clear_button.module.css';

type ClearButtonProps = ButtonProps & {
  className?: string;
  iconSize?: IconProps['size'];
};

export function ClearButton({
  className,
  'aria-label': ariaLabel = 'Clear',
  slot = 'clear',
  variant = 'tertiary',
  round = true,
  size = 's',
  icon,
  iconSize,
  ...rest
}: ClearButtonProps) {
  return (
    <Button
      slot={slot}
      aria-label={ariaLabel}
      className={cx([styles.clear_button, className])}
      variant={variant}
      round={round}
      size={size}
      icon={icon ?? <Icon name="deletion_clear" size={iconSize} />}
      {...rest}
    />
  );
}
